/**
 * Shortcuts in Editorhelp  in the full configuration we deem neccessary for the users.
 */
const full = (t, keynames) => [
  { action: t('focusMenubar'), shortcut: [keynames.alt, 'F9'] },
  { action: t('focusToolbar'), shortcut: [keynames.alt, 'F10'] },
  { action: t('focusElementPath'), shortcut: [keynames.alt, 'F11'] },
  { action: t('exitToolbar'), shortcut: [keynames.escape] },
  { action: t('header2'), shortcut: [keynames.shift, keynames.alt, '2'] },
  { action: t('header3'), shortcut: [keynames.shift, keynames.alt, '3'] },
  { action: t('header4'), shortcut: [keynames.shift, keynames.alt, '4'] },
  { action: t('paragraph'), shortcut: [keynames.shift, keynames.alt, '7'] },
  { action: t('bold'), shortcut: [keynames.ctrl, 'B'] },
  { action: t('italic'), shortcut: [keynames.ctrl, 'I'] },
  { action: t('underline'), shortcut: [keynames.ctrl, 'U'] },
  { action: t('insertLink'), shortcut: [keynames.shift, keynames.alt, 'L'] },
  { action: t('undo'), shortcut: [keynames.ctrl, 'Z'] },
  { action: t('redo'), shortcut: [keynames.ctrl, 'Y'] },
  { action: t('selectAll'), shortcut: [keynames.ctrl, 'A'] },
  { action: t('textmark'), shortcut: [keynames.ctrl, 'M'] },
  { action: t('openLanguageAbbreveation'), shortcut: [keynames.ctrl, 'Q'] },
  { action: t('fullScreen'), shortcut: [keynames.shift, keynames.alt, 'F'] },
  { action: t('abbreviation'), shortcut: [keynames.ctrl, keynames.shift, 'Q'] },
  { action: t('emoticons'), shortcut: [keynames.shift, keynames.alt, 'E'] },
];

/**
 * Shortcuts for the small tiny configuration for comments
 */
const comment = (t, keynames) => [
  { action: t('focusToolbar'), shortcut: [keynames.alt, 'F10'] },
  { action: t('exitToolbar'), shortcut: [keynames.escape] },
  { action: t('bold'), shortcut: [keynames.ctrl, 'B'] },
  { action: t('italic'), shortcut: [keynames.ctrl, 'I'] },
  { action: t('insertLink'), shortcut: [keynames.shift, keynames.alt, 'L'] },
  { action: t('selectAll'), shortcut: [keynames.ctrl, 'A'] },
  { action: t('openLanguageAbbreveation'), shortcut: [keynames.ctrl, 'Q'] },
  { action: t('abbreviation'), shortcut: [keynames.ctrl, keynames.shift, 'Q'] },
  { action: t('emoticons'), shortcut: [keynames.shift, keynames.alt, 'E'] },
];

export const shortCuts = (t, config) => {
  const keynames = {
    alt: t('alt'),
    escape: t('esc'),
    shift: t('shift'),
    ctrl: t('ctrl'),
  };
  return config === 'comment' ? comment(t, keynames) : full(t, keynames);
};
